import { useFormContext } from "react-hook-form";
import { useFetchListsAsOptions } from "@/modules/form/hooks/form";
import { FormControl, FormField, FormItem, FormLabel } from "../form";
import { StaticSelect } from "../select-new";

export function ListsField({
  filteredIds = [],
  label = "Add to list(s)",
  name = "lists",
  isMulti = true,
  type,
  maxMenuHeight = 150,
}: {
  filteredIds?: string[];
  label?: string;
  name?: string;
  isMulti?: boolean;
  type?: "static" | "dynamic";
  maxMenuHeight?: number;
}) {
  const form = useFormContext();
  const { options, isLoading } = useFetchListsAsOptions(type);
  const filteredOptions = options.filter((o) => !filteredIds.includes(o.value));

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <StaticSelect
                {...field}
                value={
                  isMulti
                    ? options.filter((o) => field.value?.includes(o.value))
                    : options.find((o) => o.value === field.value)
                }
                onChange={(val: unknown) => {
                  const castedVal = isMulti
                    ? (val as { label: string; value: string }[]).map((v) => v.value)
                    : (val as { label: string; value: string }).value;
                  field.onChange(castedVal);
                }}
                options={filteredOptions}
                isLoading={isLoading}
                isMulti={isMulti}
                maxMenuHeight={maxMenuHeight}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
}
